// extracted by mini-css-extract-plugin
export default {"comingSoon":"ComingSoon_comingSoon__Z6jGO"};